import { useSelector } from "react-redux"
export const reportMap = 
{
    808:["PICKUP_LOC_INSTRACT_REPORT","pickupRep", "bl_no desc"],
    802:["INVOICE_INSTRUCTION", "instRep","tax_id desc"],
    825:["FASAH_PAY_REPORT", "fasahPayRep", "inv_no desc"],
    822:["DO_INTEGRATION_REPORT", "doIntegrationReport", "do_number desc"],
    823:["INVOICE_DETAILS_VN", "reportGridFilterKey","inv_no desc"],
    804:["DELIVERY_ORDER_REPORT","deliveryorderRep", "bl_no desc"],
    820:["DO_EXTENSION_REPORT", "deliveryExtensionRep", "bl_no desc"],
    811:["AGENT_NOMINATION_REPORT", "agentDelegationRep", "bl_no desc"],
    816:["DETENTION_DEMURRAGE_REPORT", "detentionDemurrageRep", "bl_no desc"],
    950:["PAYMENT_DASHBOARD_REPORT", "paymentDashboardRep", "pmtmode desc"]
}
const useReportGridName = ()=>{
    const selectedInst = useSelector((state)=>state.reportDashboard.selectedInstruct)
    const reportList = useSelector((state)=>state.reportDashboard.reportList)
    


    if(reportList?.map((i)=>i.value)?.includes(+selectedInst)){
        console.log("check4", reportMap[selectedInst]?.[0], selectedInst)
        return {
            reportGridName: reportMap[+selectedInst]?.[0] ?? null,
            reportGridFilterKey: reportMap[+selectedInst]?.[1] ?? null,
            reportGridSortState: reportMap[+selectedInst]?.[2] ?? "bl_no desc"

        }
    }
    return {
        reportGridName: null,
        reportGridFilterKey: null,
        reportGridSortState: null
    }
}

export default useReportGridName